export const SET_CLUB = 'DASHBOARD/SET_CLUB';
export const SET_CLUB_ERROR = 'DASHBOARD/SET_CLUB_ERROR';
export const SET_MY_CLUB = 'DASHBOARD/SET_MY_CLUB';
export const SET_MY_CLUB_ERROR = 'DASHBOARD/SET_MY_CLUB_ERROR';
export const SET_BOOZTERS = 'DASHBOARD/SET_BOOZTERS';
export const SET_BOOZTERS_ERROR = 'DASHBOARD/SET_BOOZTERS_ERROR';
export const RESET_CLUB_DATA = 'DASHBOARD/RESET_CLUB_DATA';
export const RESET_MY_CLUB_DATA = 'DASHBOARD/RESET_MY_CLUB_DATA';
export const RESET_BOOZTERS_DATA = 'DASHBOARD/RESET_BOOZTERS_DATA';
export const SET_CLUB_ABOUT_DATA = 'DASHBOARD/SET_CLUB_ABOUT_DATA';
export const SET_CLUB_ABOUT_ERROR = 'DASHBOARD/SET_CLUB_ABOUT_ERROR';
export const SET_CLUB_ABOUT_POINTS_DATA = 'DASHBOARD/SET_CLUB_ABOUT_POINTS_DATA';
export const SET_CLUB_ABOUT_POINTS_ERROR = 'DASHBOARD/SET_CLUB_ABOUT_POINTS_ERROR';
export const SET_CLUB_UPGRADE_DATA = 'SET_CLUB_UPGRADE_DATA';
export const SET_CLUB_UPGRADE_ERROR = 'SET_CLUB_UPGRADE_ERROR';
export const SET_CLUB_SUBSCRIPTION_PAYMENT_INFO_DATA = 'SET_CLUB_SUBSCRIPTION_PAYMENT_INFO_DATA';
export const SET_CLUB_SUBSCRIPTION_PAYMENT_INFO_ERROR = 'SET_CLUB_SUBSCRIPTION_PAYMENT_INFO_ERROR';
export const SET_CLUB_SUBSCRIPTION_INFO_DATA = 'SET_CLUB_SUBSCRIPTION_INFO_DATA';
export const SET_CLUB_SUBSCRIPTION_INFO_ERROR = 'SET_CLUB_SUBSCRIPTION_INFO_ERROR';
export const SET_CLUB_SUBSCRIPTION_INVOICES_DATA = 'SET_CLUB_SUBSCRIPTION_INVOICES_DATA';
export const SET_CLUB_SUBSCRIPTION_INVOICES_ERROR = 'SET_CLUB_SUBSCRIPTION_INVOICES_ERROR';
export const UPDATE_CLUB_SUBSCRIPTION_INVOICES_DATA = 'UPDATE_CLUB_SUBSCRIPTION_INVOICES_DATA';

export const CLUB_INVOICES_PAGINATION_SIZE = 10;
